export default { orderedDocumentMetaData };

export function orderedDocumentMetaData(
  document,
  metaDefinitions,
  SystemMetadefinitions = []
) {
  return Object.keys(document)
    .filter(isFiltered)
    .map((key) => {
      const metadata = metaDefinitions.find(
        (metaData) => metaData.name === key
      );

      return {
        name: key,
        alias: metadata.alias,
        value: document[key],
        dataType: metadata.dataType,
        isMandatory: metadata.isMandatory,
        isLocked: metadata.isLocked,
        enumerables: metadata.enumerables,
        isEnumerableBased: metadata.isEnumerableBased,
        large: false,
      };
    });

  function isFiltered(key) {
    const isSystemMetaDataKey = !!SystemMetadefinitions.find(
      (systemMetadata) => systemMetadata === key
    );
    const isMetaDataKey = !!metaDefinitions.find(
      (metaData) => metaData.name === key
    );
    return !isSystemMetaDataKey && key !== "isChecked" && isMetaDataKey;
  }
}
